module.exports = __webpack_public_path__ + "media/images/lb/183-5631d4bcaa1b2d47314e673dbef9865c.svg";